export const slugify = (toBeSlugged: string) => {
  return toBeSlugged
    .toLowerCase()
    .trim()
    .replace(/[\s']/g, '-')
    .replace(/[^a-z0-9-]{1}/g, '');
};
